/**
 * mapping of poles
 */
export const poles = [
    {
        language: 'doing',
        opposite: 'delegating'
    },
    {
        language: 'delegating',
        opposite: 'doing'
    },
    {
        language: 'results',
        opposite: 'people'
    },
    {
        language: 'people',
        opposite: 'results'
    },
    {
        language: 'positivity',
        opposite: 'realism'
    },
    {
        language: 'realism',
        opposite: 'positivity'
    },
    {
        language: 'privacy',
        opposite: 'transparency'
    },
    {
        language: 'transparency',
        opposite: 'privacy'
    },
    {
        language: 'acting',
        opposite: 'planning'
    },
    {
        language: 'planning',
        opposite: 'acting'
    },
    {
        language: 'directing',
        opposite: 'collaborating'
    },
    {
        language: 'collaborating',
        opposite: 'directing'
    },
    {
        language: 'self',
        opposite: 'team'
    },
    {
        language: 'team',
        opposite: 'self'
    }
];
/**
 * statements
 */
export const statements = [
    {
        statement: `I'm naturally a strategy person, I trust others are better at handling the details on execution.`,
        primary: poles[1].language,
        secondary: poles[1].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: 'How people feel at work is less interesting to me than how well they deliver results.',
        primary: poles[2].language,
        secondary: poles[2].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I focus on what's possible and dream big rather than think about what could go wrong.`,
        primary: poles[4].language,
        secondary: poles[4].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Transparency is a great way to build trust as a leader. So I make sure my people have access to what's happening.`,
        primary: poles[7].language,
        secondary: poles[7].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I like to make decisions quickly, trust my gut, and don't tend to wait when executing ideas.`,
        primary: poles[8].language,
        secondary: poles[8].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I like to get input from others and seek to harmonize opinions rather than tell others what to do.`,
        primary: poles[11].language,
        secondary: poles[11].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `If the team can't see my value as their leader, I lose credibility. So I look for strategic ways to show my contributions.`,
        primary: poles[12].language,
        secondary: poles[12].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I like to get tasks done with careful attention to detail more than getting lost in big picture dreaming.`,
        primary: poles[0].language,
        secondary: poles[0].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I focus on helping people find ways to enjoy their work because that drives productivity more than anything else.`,
        primary: poles[3].language,
        secondary: poles[3].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I tend to focus on risks and protecting downside rather than being overly optimistic.`,
        primary: poles[5].language,
        secondary: poles[5].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I'm careful in what information I share with my people. I use discretion to protect them and/or the organization.`,
        primary: poles[6].language,
        secondary: poles[6].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I tend to be a careful planner. I prefer to gather data, analyze, and reflect before moving to execution.`,
        primary: poles[9].language,
        secondary: poles[9].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I appreciate input, but I like to decide direction rather than spend a lot of time deliberating as a group.`,
        primary: poles[10].language,
        secondary: poles[10].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I always try to put my team in the spotlight. I acknowledge their contribution and don't need them to see mine.`,
        primary: poles[13].language,
        secondary: poles[13].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I like to delegate things to others because I prefer to focus more on the big picture.`,
        primary: poles[1].language,
        secondary: poles[1].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I put a lot of attention on employee engagement, because without that performance suffers a lot.`,
        primary: poles[3].language,
        secondary: poles[3].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `I don't paint rosey pictures of the future, it sets people up for disappointment or worse, getting blindsided.`,
        primary: poles[5].language,
        secondary: poles[5].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
    {
        statement: `Information is power, so I'm selective in who I share it with. Access should be earned in my experience.`,
        primary: poles[6].language,
        secondary: poles[6].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
	{
        statement: `I operate from instinct. I know which way to go almost immediately and like to act rather than deliberate.`,
        primary: poles[8].language,
        secondary: poles[8].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
	{
        statement: `I like to make group decisions. A collaborative style may take longer, but the result is better.`,
        primary: poles[11].language,
        secondary: poles[11].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
	{
        statement: `I don't need accolades from my people, but I do subtly highlight my contributions to show relevance and build credibility.`,
        primary: poles[12].language,
        secondary: poles[12].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
	{
        statement: `I can do big picture stuff, but I don't delegate easily, I want things done right.`,
        primary: poles[0].language,
        secondary: poles[0].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
	{
        statement: `I focus more on holding people accountable at work than trying to find ways to increase morale.`,
        primary: poles[2].language,
        secondary: poles[2].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
	{
        statement: `I'm a visionary who sees exciting futures, I tend to emphasize the positive not focus on the negative.`,
        primary: poles[4].language,
        secondary: poles[4].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
	{
        statement: `Information is power, so I like err on the side of sharing more information than less with my team.`,
        primary: poles[7].language,
        secondary: poles[7].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
	{
        statement: `When making decisions, I tend to slow way down and understand the issues before taking action.`,
        primary: poles[9].language,
        secondary: poles[9].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
	{
        statement: `I have a strong point of view, so I prefer to tell my people which way to go, rather than seek consensus. `,
        primary: poles[10].language,
        secondary: poles[10].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },
	{
        statement: `When leading I don't talk about my contributions or how I add value. I'd rather celebrate what my team did.`,
        primary: poles[13].language,
        secondary: poles[13].opposite,
        primary_score: 0,
        secondary_score: 0,
        selection: null
    },

	
];